import { isEmpty, startCase } from 'lodash';

import { alphabetizeBy } from '@ion/mrdash';

import {
  useEventDebuggerTableContext,
  FILTER_KEYS,
} from 'app/event-monitoring/event-debugger/event-debugger-table/EventDebuggerTableContext';

const STATUS_KEY = 'STATUS_';

const STATIC_STATUS_SELECT_PROPS = {
  size: 'small',
  variant: 'outlined',
  label: 'Status',
};

export default function useEventDebuggerStatusSelectProps() {
  const { cluster, filterOptions, filterOptionsLoading, updateFilter, filters } = useEventDebuggerTableContext();

  const onChange = selectedStatuses => {
    updateFilter({ [FILTER_KEYS.STATUSES]: selectedStatuses });
  };

  const props = {
    ...STATIC_STATUS_SELECT_PROPS,
    options: buildOptions(filterOptions?.statuses),
    value: filters[FILTER_KEYS.STATUSES],
    disabled: filterOptionsLoading || !cluster,
    key: `${cluster}-statuses`,
    onChange,
  };

  return props;
}

function buildOptions(statuses) {
  if (isEmpty(statuses)) {
    return [{ label: 'No statuses available', value: '', disabled: true }];
  }

  const options = statuses.map(status => ({
    label: transformLabel(status),
    value: status,
  }));

  return alphabetizeBy(options, 'label');
}

function transformLabel(status) {
  const statusValue = status.startsWith(STATUS_KEY) ? status.slice(6) : status;

  const standardizedValue = statusValue.replace(/_/g, ' ').toLowerCase();

  return startCase(standardizedValue);
}
